var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.mailLoad = {
	init: function () {
		$('#mc-embedded-subscribe').click(function () {
			var emailInput = document.getElementById('mce-EMAIL');
			if (emailInput && emailInput.value) {
				$('.fa-spinner').css('display', 'inline-block');
				setTimeout(function () {
					$('.fa-spinner').css('display', 'none');
				}, 2000);
			}
		});
	},
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll('<div class=\'row ' + extraClasses + '\'></div>');
	},
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	},
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.icon = {
	init: function () {
		$('.icon.svg').each(function () {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = 'url(\'/static/files/Terra/myndmerki/' + icon + '.svg\');';
				$(this).attr('style', 'background-image: ' + style);
			}
		});
		$('.img.svg').each(function () {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = 'url(\'/static/files/Terra/starfsstodvar/' + icon + '.svg\');';
				$(this).attr('style', 'background-image: ' + style);
			}
		});
	},
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	},
});


site.fullcalendar = {
	calendar: null,
	options: null,
	init: function (element, options) {
		$(element).each(function() {
			let $this = $(this);
			let allEvents = [];
			let events = options['dates1'] !== undefined ? options.dates1 : null;
			let events2 = options['dates2'] !== undefined ? options.dates2 : null;
			let events3 = options['dates3'] !== undefined ? options.dates3 : null;
			let events4 = options['dates4'] !== undefined ? options.dates4 : null;
			if (events !== null && events !== undefined) {
				allEvents = [...allEvents, ...events]
			}
			if (events2 !== null && events2 !== undefined) {
				allEvents = [...allEvents, ...events2]
			}
			if (events3 !== null && events3 !== undefined) {
				allEvents = [...allEvents, ...events3]
			}
			if (events4 !== null && events4 !== undefined) {
				allEvents = [...allEvents, ...events4]
			}
			$this.fullCalendar({
				firstDay: 0,
				titleFormat: 'MMMM',
				monthNames: options.language.monthNames,
				dayNamesShort: options.language.dayNamesShort,
				defaultDate: allEvents[0].start,
				events: allEvents,
				eventOverlap: true,
				aspectRatio: 1,
				header: {
					left: 'prev',
					center: 'title',
					right: 'next'
				},
				contentHeight: "auto",
				displayEventTime: false,
			});
			$('.fc-left button').click(function(){
				$('.fc-view-container').addClass('faderboy');
				setTimeout(() => {
					$('.fc-view-container').removeClass('faderboy');
				}, 1000);
			});

			$('.fc-right button').click(function(){
				$('.fc-view-container').addClass('faderboy');
				setTimeout(() => {
					$('.fc-view-container').removeClass('faderboy');
				}, 1000);
			});
		});

	},
	addExtraLocationDate: function (parentCodename) {
		$('.' + parentCodename + ' .tunna__extra button').each(function () {
			$(this).on('click', () => {
				if (this.dataset.active === 'true') {
					return
				}
				const dateKey = this.dataset.key;
				const title = this.dataset.title;
				const parent = $(this).closest('.tunna__extra');
				const parentData = parent.data('extra-dates');
				const allTitles = parent.data('all-titles');
				const allEvents = $('.extras__fullcalendar').fullCalendar('clientEvents');
				allEvents.forEach(ev => {
					if (Object.values(allTitles).includes(ev.title)) {
						if (!ev.title.startsWith(title)) {
							$('.extras__fullcalendar').fullCalendar('removeEvents', ev._id);
						}
					}
				})
				let myDates = parentData[dateKey];

				myDates.forEach(date => {
					$('.extras__fullcalendar').fullCalendar('renderEvent', date, true);
				})
				$('.' + parentCodename + ' .tunna__extra button').each(function() {
					this.dataset.active = 'false';
				});
				this.dataset.active = 'true';
			});

		})
	}
};


site.store = {
	button: function () {
		// Fancy button
		var $body = $('body');
		$body.on('click', '#submitCart', function (e) {
			var $this = $(this);
			$this.parent().addClass('pressed');

			setTimeout(function () {
				$this.parent().removeClass('pressed');
				$('#storeCartBox .miniCart').trigger('click');
			}, 2000);
		});
	},
	albumImages: function () {
		$images = $('.albumImages');
		if ($images) {
			$images.find('li').each(function (i) {
				var $li = $(this);
				$li.find('a').attr('title', $li.data('title'));
			});
		}
	},
};

site.localExtras = {
	init: function () {
		var $body = $('body');

		if ($body.is('.mottokustodvarItemView')) {
			site.localExtras.mottokuCarousel();
		}
		site.localExtras.detailsToggle();
	},
	mottokuCarousel: function () {
		var $carousel = $('#extras .images');
		if ($carousel) {
			site.owl.init($carousel, {
				loop: false,
				nav: true,
				navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
				dots: false,
				autoplay: true,
				smartSpeed: 900,
				items: 1,
			});
		}
	},
	wc: function () {
		//Event calculation
		$('#vidburdur-submit').on('click touchstart', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var $event = $('#vidburdur');
			var fjoldi = $event.find('#fjoldi-vidburdur').val();
			var timi = $event.find('input[name=timi]:checked').val();
			var afengi = $event.find('input[name=afengi]:checked').val();

			var result = fjoldi / 250;

			if (result < 2) {
				result = 2;
			}
			if (timi == 12) {
				result = result * 1.5;
			}

			if (afengi == 'yes') {
				result = result * 1.3;
			}

			result = Math.ceil(result);

			$event.find('.resultNumber').text(result);
			$event.find('.resultGuest').text(fjoldi);
			$event.find('.resultTime').text(timi);

			$event.find('.intro').addClass('close');
			$event.find('.results').addClass('open');
			var order = $event.find('.results .btn');
			var url = order.attr('href');
			var n = url.indexOf('?');
			url = url.substring(0, n != -1 ? n : url.length);

			var data = {
				'fjoldi': fjoldi,
				'timi': timi,
				'result': result,
			};

			var orderInfo = url + '?textarea=Gestir: ' + data['fjoldi'] + '\nTími: ' + data['timi'] + '\nSalerni: ' + data['result'];

			order.attr('href', encodeURI(orderInfo));
		});

		// Work calculation
		$('#work-submit').on('click touchstart', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var $work = $('#vinnusvaedi');
			var fjoldi = $work.find('#fjoldi-vinnusvaedi').val();
			var result = Math.ceil(fjoldi / 10);

			$work.find('.resultNumber').text(result);
			$work.find('.resultWork').text(fjoldi);

			$work.find('.intro').addClass('close');
			$work.find('.results').addClass('open');

			var order = $work.find('.results .btn');
			var url = order.attr('href');
			var n = url.indexOf('?');
			url = url.substring(0, n != -1 ? n : url.length);

			var data = {
				'fjoldi': fjoldi,
				'result': result,
			};

			var orderInfo = url + '?textarea=Starfsmenn: ' + data['fjoldi'] + '\nSalerni: ' + data['result'];

			order.attr('href', encodeURI(orderInfo));
		});

		//Checkbox class
		$('.radioElm').on('click touchstart', function (e) {
			$(this).find('.radioElement').removeClass('checked');
			$selected = $(e.target.parentElement);
			$selected.addClass('checked');
		});
	},
	losunLookup: function () {
		var $element = $('#losun_lookup--pnr');
		if ($element) {
			$element.autocomplete({
				source: function (request, response) {
					$.ajax({
						url: '/_/moya/extras/index/misc2/' + request.term,
						dataType: 'json',
						success: function (data) {
							response(data);
						},
					});
				},
				minLength: 2,
				autoFocus: true,
				select: site.localExtras.autocompleteSelect,
				focus: site.localExtras.autocompleteFocus,
				close: site.localExtras.autocompleteClose,
			}).autocomplete('instance')._renderItem = site.localExtras.autocompleteRender;

			$element.closest('form').submit(function (e) {
				e.preventDefault();

				var term = $element.val();
				$.ajax({
					url: '/_/moya/extras/index/misc2/' + term,
					dataType: 'json',
					success: function (data) {
						if (data.length === 1 && data[0] && data[0]['url']) {
							window.location.href = data[0]['url'];
						}
					},
				});

				$(this).unbind('submit').submit();
			});
		}
	},
	autocompleteSelect: function (event, ui) {
		if (ui.item && ui.item.url) {
			window.location = ui.item.url;
		}
		return false;
	},
	autocompleteFocus: function (event, ui) {
		// Do nothing
		return false;
	},
	autocompleteClose: function (event, ui) {
		// Do nothing
		return false;
	},
	autocompleteRender: function (ul, item) {
		ul.addClass('losunSearch');
		return $('<li>')
			.append('<a class="item" href="' + item.url + '">' + item.label + '</a>')
			.appendTo(ul);
	},

	detailsToggle: function () {
		var $detailsCategory = $('.category.detailed');
		if (!$detailsCategory.length) {
			return;
		}

		site.maxHeight.init('.category.detailed .details');
		$('button.toggleDetails', $detailsCategory).on('click', function () {
			$(this).closest('.item').toggleClass('open');
		});
	},
	terraForm: function () {
		site.localExtras.terraFormLoadFinshed();
		$('.terraForm form  *:not(label):not(fieldset):not(option)').each(function () {
			var classname = 'elm ';
			classname = classname.concat($(this).attr('type') ? $(this).attr('type') : this.nodeName).toLowerCase();
			$(this).prev('label').andSelf().wrapAll('<div class="' + classname + '"/>');
		});
		$('form :input:not([type="radio"]):not([type="checkbox"]):not(select)').each(function (index, elem) {
			var eName = $(elem).attr('name');
			var label = null;
			if (eName && (label = $(elem).parents('form').find('label[for=' + eName + ']')).length === 1) {
				$(elem).attr('placeholder', $(label).html());
				$(label).addClass('hidden');
			}
		});
	},
	terraFormLoadFinshed: function () {
		$('.terraForm form').css('opacity', 1);
	},
};

site.employees = {
	branch: function () {
		$above = $('#main .above');
		if ($above) {
			$above.find('div[class^="column"]').wrapAll('<div class=\'columns\'></div>');
		}
	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
};

site.logomenu = {
	options: {
		logoElement: '#header .logo a',
		lang: {
			is: {
				getLogo: 'Sækja Terra logo',
				contactUs: 'Senda fyrirspurn',
				contactUsLink: '/is/um-okkur/hafa-samband',
			},
			en: {
				getLogo: 'Download our logo',
				contactUs: 'Contact us',
				contactUsLink: '/ens/about-stefna/contact-us',
			},
		},
	},

	getExtraMenuItems: function (nav) {
		nav.appendChild(site.logomenu.createMenuItem(site.logomenu.__('getLogo'), {
			href: '/is/logo',
			class: 'logo',
		}));
	},
};

site.carrierLink = {
	init: function () {
		let href = $('body').is('.isCompany') ? 'https://www.posturinn.is/fyrirtaeki/vorudreifing/verdskra/' :
			'https://www.posturinn.is/einstaklingar/upplysingar-einstaklingar/verdskra/';
		$('.carrierSelection label:contains("Pósturinn")').html(function (_, html) {
			return html.replace(/(gjaldskrá póstsins)/g, '<a target="_blank" href="' + href + '">$1</a>');
		});
	},
};

site.frontpage = {
	init: function () {
		var $extrasCarousel = $('#main .box_extras_category.carousel');


		if ($extrasCarousel) {
			site.owl.init($extrasCarousel.find('.category .items'), {
				nav: true,
				navText: ['<div class="arrow-right"></div>', '<div class="arrow-left"></div>'],
				dots: true,
				smartSpeed: 900,
				items: 1,
				navContainer: '#customNav',
				dotsContainer: '#customDots',
				onTranslated: site.frontpage.updateBackgroundImage,
			});
			site.frontpage.updateBackgroundImage();
		}
	},
	updateBackgroundImage: function (e) {

	},
};

site.onepager = {
	init: function () {
		$('form.moya_form :input:not([type="radio"]):not([type="checkbox"])').each(function (index, elem) {
			var eId = $(elem).attr('id');
			var label = null;
			if (eId && (label = $(elem).parents('form').find('label[for=' + eId + ']')).length === 1) {
				$(elem).attr('placeholder', $(label).html());
				$(label).addClass('hidden');
			}
		});

		$('form input[type="radio"]').click(function () {
			$('form input[type="radio"]').each(function () {
				if ($(this).is(':checked')) {
					$(this).parent().addClass('checked');
				}
				else {
					$(this).parent().removeClass('checked');
				}
			});
		});

		$('form input[type="checkbox"]').click(function () {
			$(this).parent().toggleClass('checked');
		});
	},
};

site.maillist = {
	init: function () {
		function openFancybox() {
			$.fancybox({
				'autoDimensions': false,
				'width': 650,
				'height': 350,
				'wrapCSS': 'mailChimp',
				closeEffect: 'fade',
				'content': $('.areaHidden').html(),
			});
		}

		$(document).ready(function () {
			var visited = Cookies.get('gamar-visited');
			if (visited == 'yes') {
				return false;
			}
			else {
				openFancybox();
			}
			Cookies.set('gamar-visited', 'yes', {
				expires: 7,
			});
		});
	},
};

site.contentRequires = {
	init: function () {
		function checkForInput(element) {
			// element is passed to the function ^

			$label = $(element).parent('.lmnt');

			if ($(element).val().length > 0) {
				$label.addClass('input-has-value');
			}
			else {
				$label.removeClass('input-has-value');
			}
		}

		$('.hafasamband input,.hafasamband textare').each(function () {
			checkForInput(this);
		});

		$('.hafasamband input, .hafasamband textarea').on('change keyup', function () {
			checkForInput(this);
		});
	},
};

site.jol = {
	init: function () {
		const transforms = [
			'transform',
			'msTransform',
			'webkitTransform',
			'mozTransform',
			'oTransform',
		];

		var transformProperty = getSupportedPropertyName(transforms);

		// Array to store our Snowflake objects
		var snowflakes = [];

		// Global variables to store our browser's window size
		var browserWidth;
		var browserHeight;

		// Specify the number of snowflakes you want visible
		var numberOfSnowflakes = 50;

		// Flag to reset the position of the snowflakes
		var resetPosition = false;

		function setup() {
			window.addEventListener('DOMContentLoaded', generateSnowflakes, false);
			window.addEventListener('resize', setResetFlag, false);
		}

		setup();

		// Vendor prefix management
		function getSupportedPropertyName(properties) {
			for (let i = 0; i < properties.length; i++) {
				if (typeof document.body.style[properties[i]] != 'undefined') {
					return properties[i];
				}
			}
			return null;
		}

		function Snowflake(element, radius, speed, xPos, yPos) {
			// set initial snowflake properties
			this.element = element;
			this.radius = radius;
			this.speed = speed;
			this.xPos = xPos;
			this.yPos = yPos;

			// declare variables used for snowflake's motion
			this.counter = 0;
			this.sign = Math.random() < 0.5 ? 1 : -1;

			// setting an initial opacity and size for our snowflake
			this.element.style.opacity = .1 + Math.random();
			this.element.style.fontSize = 12 + Math.random() * 50 + 'px';
		}

		// The function responsible for actually moving our snowflake
		Snowflake.prototype.update = function () {
			// using some trigonometry to determine our x and y position
			this.counter += this.speed / 5000;
			this.xPos += this.sign * this.speed * Math.cos(this.counter) / 40;
			this.yPos += Math.sin(this.counter) / 40 + this.speed / 30;

			// setting our snowflake's position
			setTranslate3DTransform(this.element, Math.round(this.xPos), Math.round(this.yPos));

			// if snowflake goes below the browser window, move it back to the top
			if (this.yPos > browserHeight) {
				this.yPos = -50;
			}
		};

		function setTranslate3DTransform(element, xPosition, yPosition) {
			element.style[transformProperty] = 'translate3d(' + xPosition + 'px, ' + yPosition + 'px' + ', 0)';
		}

		function generateSnowflakes() {
			// get our snowflake element from the DOM and store it
			let originalSnowflake = document.querySelector('.snowflake');

			// access our snowflake element's parent container
			let snowflakeContainer = originalSnowflake.parentNode;

			// get our browser's size
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;

			// create each individual snowflake
			for (let i = 0; i < numberOfSnowflakes; i++) {
				// clone our original snowflake and add it to snowflakeContainer
				const snowflakeCopy = originalSnowflake.cloneNode(true);
				snowflakeContainer.appendChild(snowflakeCopy);

				// set our snowflake's initial position and related properties
				let initialXPos = getPosition(50, browserWidth);
				let initialYPos = getPosition(50, browserHeight);
				let speed = 5 + Math.random() * 40;
				let radius = 4 + Math.random() * 10;

				// create our Snowflake object
				let snowflakeObject = new Snowflake(snowflakeCopy,
					radius,
					speed,
					initialXPos,
					initialYPos);
				snowflakes.push(snowflakeObject);
			}

			// remove the original snowflake because we no longer need it visible
			snowflakeContainer.removeChild(originalSnowflake);

			// call the moveSnowflakes function every 30 milliseconds
			moveSnowflakes();
		}

		function moveSnowflakes() {
			for (let i = 0; i < snowflakes.length; i++) {
				let snowflake = snowflakes[i];
				snowflake.update();
			}

			// Reset the position of all the snowflakes to a new value
			if (resetPosition) {
				browserWidth = document.documentElement.clientWidth;
				browserHeight = document.documentElement.clientHeight;

				for (let i = 0; i < snowflakes.length; i++) {
					let snowflake = snowflakes[i];

					snowflake.xPos = getPosition(50, browserWidth);
					snowflake.yPos = getPosition(50, browserHeight);
				}

				resetPosition = false;
			}

			requestAnimationFrame(moveSnowflakes);
		}

		// This function returns a number between (maximum - offset) and (maximum + offset)
		function getPosition(offset, size) {
			return Math.round(-1 * offset + Math.random() * (size + 2 * offset));
		}

		// Trigger a reset of all the snowflakes' positions
		function setResetFlag(e) {
			resetPosition = true;
		}
	},
};

site.tunnur = {
	init: function () {
		$('.tunna__drop button').click(function () {
			$(this).next().toggleClass('active');
			$(this).toggleClass('active');
		});
		$(document).on("click", function (event) {
			if ($(event.target).closest(".tunna__drop .tunna__drop__content").length === 0) {
				if (!event.target.classList.contains('tunna__button')) {
					$(".tunna__drop .tunna__drop__content").each(function () {
						$(this).removeClass('active');
						$(this).prev().removeClass('active');
					})
				}
			}
		});
	}
}

site.flokkun = {
	init: function () {
		$('.losun__flokkun button').click(function () {
			var extraText = $(this).closest('.item').find('.flokkun__extra');
			extraText.removeClass('hide');
			//$(this).toggleClass('open');
			extraText.toggleClass('open');
			if (extraText.hasClass('open')) {
				site.flokkun.open(extraText, $(this));
			}
			else {
				site.flokkun.close(extraText, $(this));
			}
		});
	},
	open: function (extraText, button) {
		site.maxHeight.setHeight(extraText);
		extraText.addClass('swing-in-top-fwd');
		extraText.removeClass('swing-out-top-bck');
		button.toggleClass('open');
	},
	close: function (extraText, button) {
		extraText.removeClass('swing-in-top-fwd');
		extraText.addClass('swing-out-top-bck');
		setTimeout(function () {
			button.toggleClass('open');
		}, 500);
	},
};


// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	//site.megamenu.init();
	site.accessibility.init();
	site.mailLoad.init();
	site.maillist.init();
	site.contentRequires.init();
	site.icon.init();

	//Extras
	site.localExtras.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.productView')) {
		site.store.albumImages();
		site.store.button();
	}

	if ($body.is('.employees')) {
		site.employees.branch();
	}

	if ($body.find('#moya_form_fyrirspurnir').length > 0) {
		site.onepager.init();
	}

	if ($body.is('.jol') && !$body.is('.admin')) {
		site.jol.init();
	}

	var $carousel = $('#onepagerad ul');
	if ($carousel.length > 1) {
		site.owl.init($carousel, {
			loop: true,
			nav: false,
			dots: true,
			autoplay: true,
			smartSpeed: 900,
			items: 1,
		});
	}
	var $acarousel = $('#announcements ul');
	if ($acarousel.length >= 1) {
		$('<div class="slider-counter"></div>').insertAfter('#announcements');
		site.owl.init($acarousel, {
			loop: true,
			nav: true,
			dots: false,
			autoplay: false,
			autoHeight: true,
			smartSpeed: 900,
			items: 1,
			navText: ['', ''],
			autoplayHoverPause: true,
			animateOut: 'slideOutUp',
			animateIn: 'slideInUp',
			onInitialized: counter,
			onInitialize: counter,
			onTranslated: counter,
		});

		function counter(event) {
			if (!event.namespace) {
				return;
			}
			var slides = event.relatedTarget;
			$('.slider-counter').text(slides.relative(slides.current()) + 1 + '/' + slides.items().length);
		}

		$('.slider-counter').insertAfter('#announcements .owl-nav .owl-prev');
	}

	site.svg.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	$('#losun_lookup_form').submit(function (e) {
		if ($('.losunSearch')[0]) {
			e.preventDefault();
			window.location = $('.losunSearch li:first-child a').attr('href');
		}
	});

	if ($('.stepperContent.shipping').length > 0) {
		site.carrierLink.init();
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
